import React, {
  useState,
  ChangeEvent,
  useEffect,
  useRef,
  useMemo,
} from "react";
import {
  registerHarvestDetails,
  getHarvestDetailsById,
  getHarvestDetailsApplicationById,
  saveRFAResponse,
  checkHarvestAppliactionDetailsByHDId,
  updateHarvestDetails,
  checkLicenceExistance,
  checkPremiseCodeExistance,
  getMicrochipNumbers,
  getMicrochipRegistrations,
  updateExpiryDate,
  PremiseCodeDetails,
} from "../../api/apimethods";
import { useNavigate, useLocation } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { countryMobileCodes } from "../../scripts/countryMobileCodes";
import {
  IHarvestDetailsRegistrationRequest,
  IHarvestApplicationAttachmentRequest,
} from "../../typings/interfaces/Requests/HarvestDetailsRegistrationRequest";
import { IHarvestApplicationRFARequest } from "../../typings/interfaces/Requests/HarvestApplicationRFARequest";
import { Holiday } from "../../typings/models/Holiday";
import fetchHolidaysMaster from "../../scripts/holidaysMaster";
import { IcountryOptions } from "../../typings/models/CountryOption";
import fetchCountryOptions from "../../scripts/countryOptions";
import HarvestDetailsRFA from "./HarvestDetailsRFA";
import Select from "react-select";
import { IMicrochipRegistrationResponseModel } from "../../typings/models/MicrochipRegistrationResponseModel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setHours, setMinutes } from 'date-fns';
import { AppContext, defaultAppContextData } from "../../services/appData";
import { useConfig } from "../../context/ConfigProvider";
import { useAuthService, useContextService } from "../../services";
import Loader from "../../components/molecules/Loader";
interface Option {
  value: string;
  label: string;
}

const HarvestDetailsRegistration: React.FC = () => {
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const user = contextData.user;

  const inputHolidayRef = useRef(true);
  const inputCountryRef = useRef(true);
  const inputUserRef = useRef(true);
  const [requestType, setRequestType] = useState("1");
  const [errorMessage, setErrorMessage] = useState("");
  const [isalutation, setiSalutation] = useState("0");
  const [iapplicantName, setiApplicantName] = useState("");
  const [iUEN, setiUEN] = useState("");
  const [icompanyName, setiCompanyName] = useState("");
  const [ilicencenumber, setiLicenceNumber] = useState("");
  const [ipremiseCode, setiPremiseCode] = useState("");
  const [iorganizationAddress, setiOrganizationAddress] = useState("");
  const [iorganizationAddress2, setiOrganizationAddress2] = useState("0");
  const [iorganizationAddress3, setiOrganizationAddress3] = useState("");
  const [iorganizationAddress4, setiOrganizationAddress4] = useState("");
  const [iorganizationAddress5, setiOrganizationAddress5] = useState("");
  const [iorganizationAddress6, setiOrganizationAddress6] = useState("");
  const [iorganizationAddress7, setiOrganizationAddress7] = useState("");
  const [iorganizationAddress8, setiOrganizationAddress8] = useState("");
  const [iorganizationAddress9, setiOrganizationAddress9] = useState("");
  const [iorganizationAddress10, setiOrganizationAddress10] = useState("");
  const [country, setCountry] = useState("");
  const [imobileNo, setiMobileNo] = useState("");
  const [imobilecode, setiMobileCode] = useState("+65");
  const [iemail, setiEmail] = useState("");
  const [brooderMicrochipNumber, setBrooderMicrochipNumber] =
    useState<Option | null>(null);
  // const [batchNumber, setBatchNumber] = useState("");
  const [quantity, setQuantity] = useState("");
  const [variety, setVariety] = useState("");
  const [harvestDate, setHarvestDate] = useState<Date | null>(null);
  const [harvestTime, setHarvestTime] = useState<Date | null>(
    setHours(setMinutes(new Date(), 0), 9)
  );
  const [aRemarks, setaRemarks] = useState("");
  const [comments, setComments] = useState("");

  const [validEmail, setValidEmail] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [isalutationSelected, setiSalutationSelected] = useState(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  //Date validation
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1); // Set it to tomorrow
  const minDate = currentDate; //.toISOString().split("T")[0];

  const [floorNoShowError, setfloorNoShowError] = useState(true);
  const [unitNoShowError, setunitNoShowError] = useState(true);
  const [blockNoShowError, setblockNoShowError] = useState(true);
  const [postalCodeShowError, setpostalCodeShowError] = useState(true);
  const [validMobileNo, setValidMobileNo] = useState(true);
  const [afloorNoShowError, setafloorNoShowError] = useState(true);
  const [aunitNoShowError, setaunitNoShowError] = useState(true);
  const [ablockNoShowError, setablockNoShowError] = useState(true);
  const [apostalCodeShowError, setapostalCodeShowError] = useState(true);
  const [validaMobileNo, setValidaMobileNo] = useState(true);
  const [isCaptchaValid, setIsCaptchaValid] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmiting, setSubmiting] = useState(false);
  const [isValidDate, setisValidDate] = useState(true);
  const [isTimeValid, setTimeValid] = useState(true);
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const [countries, setCountries] = useState<IcountryOptions[]>([]);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableUpload, setDisableUpload] = useState(false);
  const [disableFormFields, setDisableFormFields] = useState(false);
  const [licenceNumberNoShowError, setLicenceNumberNoShowError] =
    useState(true);
  const [premiseCodeNoShowError, setPremiseCodeNoShowError] = useState(true);
  const [harvestDetailsApplicationStatus, setHarvestDetailsApplicationStatus] =
    useState("");
  const [showExtend, setShowExtend] = useState(false);
  const [extendExpiryDate, setExtendExpiryDate] = useState("");
  const [expiryDate, setExpiryDate] = useState<Date | null>(null);

  let navigate = useNavigate();
  const location = useLocation();
  let harvestDetailsId = location.state?.id;
  let applicationStatus = location.state?.status;
  let mode = location.state?.mode;
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [base64Files, setBase64Files] = useState<
    { fileName: string; file: string }[]
  >([]);
  const [base64FilesSingle, setBase64FilesSingle] = useState<string[]>([]);
  const [showRFAFields, setShowRFAFields] = useState(false);
  const [editMode, setEditMode] = useState("");
  const formRef = useRef<HTMLFormElement | null>(null);
  const [microchipNumbers, setMicrochipNumbers] = useState<Option[]>([]);
  const [microchipRegData, setMicrochipRegData] = useState<
    IMicrochipRegistrationResponseModel[]
  >([]);

  const [applicationid, setApplicationId] = useState("");
  const [requestReferenceNumber, setRequestReferenceNumber] = useState("");
  // let applicationid = "";

  const [regRfaStatus, setRegRfaStatus] = useState("");
  const [regRfaCategory, setRegRfaCategory] = useState("");
  const RfaStatus = (data: string) => {
    setRegRfaStatus(data);
  };

  var rfaCategory = "";
  var rfaStatus = "";

  const getRfaData = (category: string, status: string) => {
    rfaCategory = category;
    rfaStatus = status;
    setDisableFormFields(false);
    if (mode != undefined && mode === "view") {
      setRequestType("1");
      if (
        status == "0" &&
        (applicationStatus == "5" || harvestDetailsApplicationStatus == "5")
      ) {
        setShowExtend(false);
        if (category == "1") {
          setDisableUpload(true);
          setDisableSubmit(false);
          setEditMode("edit");
        } else if (category == "2") {
          setDisableFormFields(true);
          setDisableSubmit(false);
          setDisableUpload(false);
          setEditMode("edit");
        } else if (category == "3") {
          setDisableFormFields(true);
          setDisableSubmit(false);
          setDisableUpload(true);
          setShowRFAFields(true);
        } else if (category == "1,2") {
          setDisableFormFields(false);
          setDisableSubmit(false);
          setDisableUpload(false);
          setShowRFAFields(false);
        } else if (category == "1,3") {
          setDisableFormFields(false);
          setDisableSubmit(false);
          setDisableUpload(true);
          setShowRFAFields(true);
        } else if (category == "2,3") {
          setDisableFormFields(true);
          setDisableSubmit(false);
          setDisableUpload(false);
          setShowRFAFields(true);
        } else if (category == "1,2,3") {
          setDisableSubmit(false);
          setDisableUpload(false);
          setShowRFAFields(true);
        } else setDisableSubmit(false);
      } else {
        setShowRFAFields(false);
        setDisableSubmit(true);
        setDisableUpload(true);
      }
    } else {
      setDisableSubmit(false);
    }
  };

  const handleUploadButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const base64Promises = Array.from(files).map((file) => {
        return new Promise<{ fileName: string; file: string }>((resolve) => {
          const reader = new FileReader();
          reader.onload = (e) => {
            if (e.target) {
              const result = e.target.result as string;
              resolve({ fileName: file.name, file: result.split(",")[1] });
            }
          };
          reader.readAsDataURL(file);
        });
      });
      Promise.all(base64Promises).then((base64Array) => {
        setBase64Files(base64Array);
      });

      setSelectedFiles([...selectedFiles, ...Array.from(files)]);
    }
  };

  const isWeekend = (date: any) => {
    const day = date.getDay();
    return day === 0 || day === 6; // Sunday (0) or Saturday (6)
  };

  const isHoliday = (date: any) => {
    const dateString = date.toISOString().split("T")[0];
    return holidays.some(
      (holiday) =>
        // holiday.holidayDate.split("T")[0].includes(dateString)
        date.toDateString() === new Date(holiday.holidayDate).toDateString()
    );
  };

  const fixTimezoneOffset = (date: Date | null): Date | null => {
    if (!date) return null;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  };

  const getTimezoneOffset = (date: Date): Date | null => {
    const newDate = new Date(date);
    const userTimezoneOffset = Math.abs(newDate.getTimezoneOffset() * 60000);
    return new Date(newDate.getTime() - userTimezoneOffset);
  };

  // Handle holiday vaidation
  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    const selectedDateObj = new Date(selectedDate);

    if (isWeekend(selectedDateObj) || isHoliday(selectedDateObj)) {
      // If the selected date is a weekend or a holiday, prevent updating the state
      event.preventDefault();
      setisValidDate(false);
      // setHarvestDate("");
    } else {
      // setHarvestDate(selectedDate);
      setisValidDate(true);
    }
  };

  //time validation
  const isValidTime = (time: any) => {
    const selectedTime = new Date(`2000-01-01T${time}`);
    const minTime = new Date(`2000-01-01T09:00`);
    const maxTime = new Date(`2000-01-01T17:00`);

    return selectedTime >= minTime && selectedTime <= maxTime;
  };

  const convertTo24HourFormat = (time: any) => {
    const [hours, minutes] = time.split(":");
    let hoursInt = parseInt(hours, 10);
    if (hoursInt < 12 && time.includes("PM")) {
      hoursInt += 12;
    }
    return `${hoursInt.toString().padStart(2, "0")}:${minutes}`;
  };

  const blockNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setiOrganizationAddress3(value);
      setblockNoShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress3(value);
        setblockNoShowError(true);
      } else {
        setblockNoShowError(false);
      }
    }
  };

  const postalCodeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;
    setiOrganizationAddress9(value);
    if (pattern.test(value)) {
      setpostalCodeShowError(true);
    } else {
      if (value === "") {
        setpostalCodeShowError(true);
      } else {
        setpostalCodeShowError(false);
      }
    }
  };
  useEffect(() => {
    if (ipremiseCode) {
      const fetchPremiseDetails = async () => {
        try {
          const response = await PremiseCodeDetails(ipremiseCode);

          if (response.data) {
            setiOrganizationAddress3(response.data.blockHouseNumber || "");
            setiOrganizationAddress5(response.data.streetRoadName || "");
            setiOrganizationAddress6(response.data.floorNumber || "");
            setiOrganizationAddress7(response.data.unitNumber || "");
            setiOrganizationAddress8(response.data.buildingName || "");
            const postalCodeWithoutSpaces = response.data.postalCode.replace(
              /\s/g,
              ""
            );
            setiOrganizationAddress9(postalCodeWithoutSpaces || "");
          }
        } catch (error) {
          console.error("Failed to fetch premise details", error);
        }
      };

      fetchPremiseDetails();
    }
  }, [ipremiseCode]);
  const unitNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (new RegExp(pattern).test(value)) {
      setiOrganizationAddress7(value);
      setunitNoShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress7(value);
        setunitNoShowError(true);
      } else {
        setunitNoShowError(false);
      }
    }
  };

  const floorNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[a-zA-Z0-9\s]+$/;

    if (pattern.test(value)) {
      setiOrganizationAddress6(value);
      setfloorNoShowError(true);
    } else {
      if (value === "") {
        setiOrganizationAddress6(value);
        setfloorNoShowError(true);
      } else {
        setfloorNoShowError(false);
      }
    }
  };

  const mobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      setiMobileNo(value);
      if (value.length < 8) {
        setValidMobileNo(false);
      } else {
        setValidMobileNo(true);
      }
    } else {
      if (value === "") {
        setiMobileNo(value);
        setValidMobileNo(true);
      } else {
        setValidMobileNo(false);
      }
    }
  };

  const amobileNoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[0-9]+$/;

    if (pattern.test(value)) {
      if (value.length <= 8) {
        setValidaMobileNo(false);
      } else {
        setValidaMobileNo(true);
      }
    } else {
      if (value === "") {
        setValidaMobileNo(true);
      } else {
        setValidaMobileNo(false);
      }
    }
  };

  useEffect(() => {
    if (inputCountryRef.current) {
      inputCountryRef.current = false;
      const fetchData = async () => {
        const countries = await fetchCountryOptions();
        setCountries(countries);
        setIsLoading(false);
        const defaultCountry = countries.find(
          (option) => option.label === "Singapore"
        )?.value;
        if (defaultCountry !== undefined) {
          setiOrganizationAddress10(defaultCountry);
        }
      };

      fetchData();
    }
  }, []);

  useEffect(() => {
    if (inputUserRef.current) {
      inputUserRef.current = false;
      if (user !== undefined) {
        if (user.uen != undefined) setiUEN(user.uen);
        if (user.companyName != undefined) setiCompanyName(user.companyName);
        if (user.name != undefined) setiApplicantName(user.name);
        // if (user.idNo != undefined) setiNRIC(user.idNo);
        if (user.contactNo != undefined) {
          setiMobileCode(user.contactNo.substring(0, 3));
          setiMobileNo(user.contactNo.substring(3));
        }
        if (user.email != undefined) setiEmail(user.email);
        if (user.registeredAddresses != undefined) {
          setiOrganizationAddress("1");
          setiOrganizationAddress9(user?.registeredAddresses?.[0]?.postalCode);
          setiOrganizationAddress3(
            user?.registeredAddresses?.[0]?.blockHouseNo
          );
          setiOrganizationAddress5(user?.registeredAddresses?.[0]?.streetName);
          setiOrganizationAddress6(user?.registeredAddresses?.[0]?.floorLevel);
          setiOrganizationAddress7(user?.registeredAddresses?.[0]?.unit);
          setiOrganizationAddress8(
            user?.registeredAddresses?.[0]?.buildingName
          );
        }
      }
    }
    if (inputHolidayRef.current) {
      inputHolidayRef.current = false;
      const fetchHolidaysData = async () => {
        const holidaysData = await fetchHolidaysMaster();
        setHolidays(holidaysData);
      };

      fetchHolidaysData();
    }
  }, []);

  useEffect(() => {
    const microchipNumbers = async () => {
      var response = null;
      // response = await getMicrochipNumbers();
      response = await getMicrochipRegistrations("", 3, "");
      if (response.data) {
        const data = response.data;

        // Assuming your API response has an array of options
        const apiOptions: Option[] = data.map((item: any) => ({
          value: item.id.toString(),
          label: item.microchipNumber,
        }));

        setMicrochipNumbers(apiOptions);
        setMicrochipRegData(response.data);
      }
    };
    microchipNumbers();
  }, []);

  useEffect(() => {
    if (harvestDetailsId == undefined) {
      setRequestType("1");
    } else {
      try {
        const fetchDataToEdit = async () => {
          var response = null;
          if (mode != undefined && mode === "view") {
            response = await getHarvestDetailsApplicationById(harvestDetailsId);
          } else {
            setRequestType("2");
            response = await getHarvestDetailsById(harvestDetailsId);
          }
          if (response.data) {
            if (mode == "amend") {
              // let applicationNumber = response.data[0].requestReferenceNumber;
              var applicationExists =
                await checkHarvestAppliactionDetailsByHDId(harvestDetailsId);
              // setRequestReferenceNumber(applicationNumber);
              if (applicationExists.data) {
                setDisableSubmit(true);
                window.alert(
                  "Cannot amend this request as there is an application submitted for this."
                );
              } else {
                setShowExtend(false);
              }
            } else if (mode == "extend") {
              setShowExtend(true);
              setDisableFormFields(true);
              setDisableUpload(true);
              setDisableSubmit(false);
            }
            if (response.data[0].harvestDetailsApplicationId != undefined) {
              setApplicationId(response.data[0].harvestDetailsApplicationId);
            }
            if (response.data[0].harvestDetailsId != undefined) {
              setApplicationId(response.data[0].harvestDetailsId);
            }
            setRequestType("2");
            if (response.data[0].salutation != undefined)
              setiSalutation(response.data[0].salutation);
            setiApplicantName(response.data[0].name);
            setiUEN(response.data[0].uen);
            if (response.data[0].companyName != undefined)
              setiCompanyName(response.data[0].companyName);
            if (response.data[0].licenceNumber != undefined)
              setiLicenceNumber(response.data[0].licenceNumber);
            if (response.data[0].premiseCode != undefined)
              setiPremiseCode(response.data[0].premiseCode);
            if (response.data[0].mobileNo != undefined)
              setiMobileNo(response.data[0].mobileNo);
            if (response.data[0].email != undefined)
              setiEmail(response.data[0].email);
            if (response.data[0].addressType != undefined)
              setiOrganizationAddress(response.data[0].addressType);
            if (response.data[0].typeofPremises != undefined)
              setiOrganizationAddress2(response.data[0].typeofPremises);
            if (response.data[0].blockHouseNumber != undefined)
              setiOrganizationAddress3(response.data[0].blockHouseNumber);
            if (response.data[0].streetName != undefined)
              setiOrganizationAddress5(response.data[0].streetName);
            if (response.data[0].floorNumber != undefined)
              setiOrganizationAddress6(response.data[0].floorNumber);
            if (response.data[0].unitNumber != undefined)
              setiOrganizationAddress7(response.data[0].unitNumber);
            if (response.data[0].buildingName != undefined)
              setiOrganizationAddress8(response.data[0].buildingName);
            if (response.data[0].postalCode != undefined)
              setiOrganizationAddress9(response.data[0].postalCode);
            if (response.data[0].country != undefined)
              setiOrganizationAddress10(response.data[0].country);
            if (response.data[0].quantityofHarvestedLarvae != undefined)
              setQuantity(response.data[0].quantityofHarvestedLarvae);
            if (response.data[0].variety != undefined)
              setVariety(response.data[0].variety);
            if (response.data[0].remarks != undefined)
              setaRemarks(response.data[0].remarks);
            if (response.data[0].harvestDate != undefined)
              setHarvestDate(new Date(response.data[0].harvestDate));
            if (response.data[0].harvestDate != undefined) {
              let date = getTimezoneOffset(
                new Date(response.data[0].harvestDate)
              );
              setHarvestTime(date);
            }
            if (response.data[0].brooderMicrochipNumber != undefined) {
              var micNo = response.data[0].brooderMicrochipNumber;
              var brooderMicrochipNo = microchipNumbers.find(
                (option) => option.value === micNo
              );
              if (brooderMicrochipNo != undefined)
                setBrooderMicrochipNumber(brooderMicrochipNo);
            }
            if (response.data[0].expiryDate != undefined)
              setExpiryDate(response.data[0].expiryDate);
            if (response.data[0].harvestDetailsStatus != undefined) {
              setHarvestDetailsApplicationStatus(
                response.data[0].harvestDetailsStatus
              );
              applicationStatus = response.data[0].harvestDetailsStatus;
            }
            getRFAResponse();
          } else {
            // API call failed
          }
          setCountries(countries);
          setIsLoading(false);
        };
        fetchDataToEdit();
      } catch (error) {
        setIsLoading(false);
      }
    }
  }, [harvestDetailsId]);

  const getRFAResponse = () => {
    if (mode != undefined && mode === "view") {
      setRequestType("1");
      if (
        rfaStatus == "0" &&
        (applicationStatus == "5" || harvestDetailsApplicationStatus == "5")
      ) {
        if (rfaCategory == "1") {
          setDisableUpload(true);
          setDisableSubmit(false);
          setEditMode("edit");
        } else if (rfaCategory == "2") {
          setDisableFormFields(true);
          setDisableSubmit(false);
          setDisableUpload(false);
          setEditMode("edit");
        } else if (rfaCategory == "3") {
          setDisableFormFields(true);
          setDisableSubmit(false);
          setDisableUpload(true);
          setShowRFAFields(true);
          setEditMode("RFA");
        } else if (rfaCategory == "1,2") {
          setDisableFormFields(false);
          setDisableSubmit(false);
          setDisableUpload(false);
          setShowRFAFields(false);
          setEditMode("edit");
        } else if (rfaCategory == "1,3") {
          setDisableFormFields(false);
          setDisableSubmit(false);
          setDisableUpload(true);
          setShowRFAFields(true);
          setEditMode("edit");
        } else if (rfaCategory == "2,3") {
          setDisableFormFields(true);
          setDisableSubmit(false);
          setDisableUpload(false);
          setShowRFAFields(true);
          setEditMode("edit");
        } else if (rfaCategory == "1,2,3") {
          setDisableSubmit(false);
          setDisableUpload(false);
          setShowRFAFields(true);
          setEditMode("edit");
        } else setDisableSubmit(false);
      } else {
        setShowRFAFields(false);
        setDisableSubmit(true);
        setDisableUpload(true);
      }
    }
  };
  // useEffect(() => {
  //   if (applicationStatus === "5") setShowRFAFields(true);
  // }, [applicationStatus]);

  const splitDateTime = (dateTimeString: string) => {
    const [datePart, timePart] = dateTimeString.split("T");
    return { datePart, timePart };
  };

  const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    var index = event.target.selectedIndex;
    setCountry(event.target.options[index].text);
    setiOrganizationAddress10(event.target.value);
  };

  const handleLicenceNumberBlur = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    var licenceNumber = event.target.value;
    if (licenceNumber?.length > 0) {
      var response = await checkLicenceExistance(licenceNumber);
      if (!response.data) {
        setLicenceNumberNoShowError(false);
        setDisableSubmit(true);
      } else {
        setDisableSubmit(false);
        setLicenceNumberNoShowError(true);
        var filteredData = microchipRegData.filter(
          (opt) =>
            opt.licenceNumber?.toUpperCase() === licenceNumber?.toUpperCase()
        );

        const apiOptions: Option[] = filteredData.map((item: any) => ({
          value: item.id.toString(),
          label: item.microchipNumber,
        }));

        setBrooderMicrochipNumber(null);
        setVariety("");
        setMicrochipNumbers(apiOptions);
      }
    } else {
      setLicenceNumberNoShowError(true);
    }
  };

  const handlePremiseCodeBlur = async (
    event: React.FocusEvent<HTMLInputElement>
  ) => {
    var response = await checkPremiseCodeExistance(event.target.value);
    if (!response.data) {
      setPremiseCodeNoShowError(false);
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
      setPremiseCodeNoShowError(true);
    }
  };

  const handleBrooderMicrochipChange = (selectedOption: any) => {
    var value = selectedOption.value;
    var microchipRegistration = microchipRegData.filter((m) => m.id === value);

    if (microchipRegistration) {
      setVariety(microchipRegistration[0].varietyofFish.toString());
      var brooderMicrochipNo = microchipNumbers.find(
        (option) => option.value === value
      );
      if (brooderMicrochipNo != undefined)
        setBrooderMicrochipNumber(brooderMicrochipNo);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    try {
      var type = "";
      setSubmitted(true);
      const reCaptchaResponse = recaptchaRef.current?.getValue();
      let saltuation = isSalutationSelected();
      setiSalutationSelected(saltuation);
      // if (!reCaptchaResponse) {
      //   // reCAPTCHA validation failed
      //   setIsCaptchaValid(false);
      //   return;
      // }
      if (isValidDate && checkboxChecked && saltuation && validEmail) {
        var response = null;
        setSubmiting(true);
        let replyResponse: boolean | undefined = false;
        if (comments != "") {
          handleReplyClick().then((value) => {
            replyResponse = value;
            if (editMode === "RFA" && replyResponse) {
              setSubmiting(false);
              let refNumber = "";
              let path = `/harvest-details-complete`;
              navigate(path, { state: { refNumber, editMode } });
            }
          });
        }
        if (editMode == "") {
          if (!showExtend)
            response = await registerHarvestDetails(harvestDetailsRequestData);
          else {
            type = "extend";
            if (expiryDate != null)
              response = await updateExpiryDate(
                applicationid,
                expiryDate.toString()
              );
          }
        } else if (editMode == "edit") {
          response = await updateHarvestDetails(
            applicationid,
            harvestDetailsRequestData
          );
        } else if (editMode == "RFA" && replyResponse) {
          let refNumber = "";
          let path = `/harvest-details-complete`;
          navigate(path, { state: { refNumber, editMode, type } });
        }

        if (editMode !== "RFA")
          if (response?.data) {
            setSubmiting(false);

            let refNumber = response.data;
            let path = `/harvest-details-complete`;
            navigate(path, { state: { refNumber, editMode } });
          } else {
            // API call failed
            setSubmiting(false);
            const errorMessage = "An error occurred. Please try again.";
            setErrorMessage(errorMessage); // Set the error message in state
          }

        // Handle the API response
      }
    } catch (error) {
      // Handle any errors
      setSubmiting(false);
      console.error(error);
    }
  }

  const handleNewReg = () => {
    // let path = `/harvest-details`;
    // navigate(path);
    window.location.reload();
  };

  (function () {
    

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll(".needs-validation");

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function (form) {
      form.addEventListener(
        "submit",
        function (event: any) {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  })();
  // Include the applicantName value in your API request
  // Prepare the request payload
  const harvestDetailsRequestData: IHarvestDetailsRegistrationRequest = {
    requestType: requestType,
    harvestDetailsId: applicationid,
    salutation: isalutation,
    name: iapplicantName,
    uen: iUEN,
    companyName: icompanyName,
    licenceNumber: ilicencenumber,
    premiseCode: ipremiseCode,
    addressType: iorganizationAddress,
    mobileNo: imobileNo,
    email: iemail,
    typeofPremises: iorganizationAddress2,
    blockHouseNumber: iorganizationAddress3,
    houseNumber: iorganizationAddress4,
    streetName: iorganizationAddress5,
    floorNumber: iorganizationAddress6,
    unitNumber: iorganizationAddress7,
    buildingName: iorganizationAddress8,
    postalCode: iorganizationAddress9,
    country: iorganizationAddress10,
    mobileNoCode: imobilecode,
    brooderMicrochipNumber: brooderMicrochipNumber?.value!,
    // batchNumber: batchNumber,
    quantity: quantity,
    variety: variety,
    harvestDate: fixTimezoneOffset(harvestDate),
    harvestTime: fixTimezoneOffset(harvestTime) ?? null,
    remarks: aRemarks,
    supportingDocuments: base64Files,
    userInformation: {
      name: user?.name,
      idType: user?.idType,
      idNo: user?.idNo,
      email: user?.email,
      contactNo: user?.contactNo,
      companyName: user?.companyName,
      uen: user?.uen,
      registeredAddress: user?.registeredAddresses?.[0],
    },
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setiEmail(value);
    if (pattern.test(value)) {
      setValidEmail(true);
    } else {
      if (value === "") {
        setValidEmail(true);
      } else {
        setValidEmail(false);
      }
    }
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxChecked(event.target.checked);
  };

  const isSalutationSelected = () => {
    return isalutation !== null && isalutation !== "0";
  };

  const harvestApplicationRFARequestData: IHarvestApplicationRFARequest = {
    applicantsComments: comments,
    harvestDetailsApplicationId: applicationid,
  };

  const handleReplyClick = async () => {
    try {
      var response = null;
      response = await saveRFAResponse(harvestApplicationRFARequestData);
      if (response.data) {
        // let path = `/harvest-details`;
        // navigate(path, { state: { id: applicationid, mode: "view" } });
        // alert("RFA response updated.");
        return true;
      } else {
        // API call failed
        const errorMessage = "An error occurred. Please try again.";
        setErrorMessage(errorMessage); // Set the error message in state
        return false;
      }

      // Handle the API response
    } catch (error) {
      // Handle any errors
      setSubmiting(false);
      console.error(error);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-9">
          <h2>Declaration</h2>
        </div>
        <div className="col-lg-3">
          <button
            className="btn btn-success d-block"
            onClick={() => handleNewReg()}
          >
            New Registration
          </button>
        </div>
      </div>
      <div className="inst-cnt mb-2">
        <div className="form-check">
           <input
            className="form-check-input"
            type="checkbox"
            checked={checkboxChecked}
            onChange={handleCheckboxChange}
            id="flexCheckDefault"
            required
          />
          <label className="form-check-label" htmlFor="flexCheckDefault">
            I certify that the information given is true and complete to the
            best of my knowledge.
          </label>
          {submitted && !checkboxChecked && (
            <p className="error-message">
              Please confirm the declaration checkbox
            </p>
          )}
        </div>
      </div>
      <h2 className="pb-2">Registration</h2>
      <div className="inst-cnt mt-4 mb-2">
        <span className="est-time">
          <i className="fas fa-clock"></i> Estimated time to complete: 15 mins
        </span>
      </div>
      <form
        ref={formRef}
        className="row g-3 needs-validation"
        onSubmit={handleSubmit}
        noValidate
      >
        <h2 className="pb-0">User Information</h2>
        <div className="inst-cnt mt-4 mb-2">
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">{user.name}</label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  NRIC :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">{user.idNo}</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Mobile Number :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.contactNo}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Email :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">{user.email}</label>
              </div>
            </div>
          </div>
          <div className="row">
            <label htmlFor="name" className="form-label mb-2 fw-bold">
              Address
            </label>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Block/House Number :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.blockHouseNo}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Floor Number :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.floorLevel}
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Street Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.streetName}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Unit Number :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.unit}
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 row">
              <div className="col-md-5">
                <label htmlFor="name" className="form-label mb-2">
                  Building Name :
                </label>
              </div>
              <div className="col-md-7">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.buildingName}
                </label>
              </div>
            </div>
            <div className="col-lg-6 row">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label mb-2 mr-10">
                  Postal Code :
                </label>
              </div>
              <div className="col-md-8">
                <label className="form-label mb-2 fw-bold">
                  {user.registeredAddresses?.[0]?.postalCode}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div
          className="passport-details hidden csp-display-block"
          id="passport"
        >
          <h2 className="pb-0">Personal Information</h2>
          <div className="inst-cnt mt-2">
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className={`form-label mb-2 ${
                  !isSalutationSelected() ? "required" : ""
                }`}
              >
                1. Salutation <span className="star">*</span>{" "}
              </label>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Dr"
                  id="flexRadioDefault11"
                  checked={isalutation === "Dr"}
                  onChange={() => setiSalutation("Dr")}
                  disabled={disableFormFields}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault11"
                >
                  Dr
                </label>
              </div>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Mdm"
                  id="flexRadioDefault22"
                  checked={isalutation === "Mdm"}
                  onChange={() => setiSalutation("Mdm")}
                  disabled={disableFormFields}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault22"
                >
                  Mdm
                </label>
              </div>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Miss"
                  id="flexRadioDefault33"
                  checked={isalutation === "Miss"}
                  onChange={() => setiSalutation("Miss")}
                  disabled={disableFormFields}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault33"
                >
                  Miss
                </label>
              </div>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Mr"
                  id="flexRadioDefault55"
                  checked={isalutation === "Mr"}
                  onChange={() => setiSalutation("Mr")}
                  disabled={disableFormFields}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault55"
                >
                  Mr
                </label>
              </div>
              <div
                className={`form-check ${
                  !isSalutationSelected() ? "is-invalid" : ""
                }`}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  name="ssalutation"
                  value="Mrs"
                  id="flexRadioDefault66"
                  checked={isalutation === "Mrs"}
                  onChange={() => setiSalutation("Mrs")}
                  disabled={disableFormFields}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexRadioDefault66"
                >
                  Mrs
                </label>
              </div>
              {submitted && !isSalutationSelected() && (
                <div className="invalid-feedback">
                  Please select a Salutation.
                </div>
              )}
            </div>
            <div className="mb-2">
              <label htmlFor="sapplicantName" className="form-label mb-2">
                2. Name of Applicant <span className="star">*</span>{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="sapplicantName"
                placeholder="Type Applicant Name as per NRIC / Passport"
                value={iapplicantName}
                maxLength={255}
                onChange={(event) => setiApplicantName(event.target.value)}
                disabled={disableFormFields}
                required
              />
              <div className="invalid-feedback">
                Please provide a Applicant Name.
              </div>
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                3. UEN <span className="star">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="sUEN"
                placeholder=""
                maxLength={12}
                value={iUEN}
                onChange={(event) => setiUEN(event.target.value)}
                disabled={disableFormFields}
                required
              />
              <div className="invalid-feedback">Please provide a UEN.</div>
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                4. Company Name
              </label>
              <input
                type="text"
                className="form-control"
                id="scompanyName"
                placeholder=""
                maxLength={100}
                value={icompanyName}
                onChange={(event) => setiCompanyName(event.target.value)}
                disabled={disableFormFields}
              />
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                5. Farm Licence Number
              </label>
              <input
                type="text"
                className="form-control"
                id="slicencenumber"
                placeholder=""
                maxLength={100}
                value={ilicencenumber}
                onChange={(event) => setiLicenceNumber(event.target.value)}
                disabled={disableFormFields}
                onBlur={handleLicenceNumberBlur}
              />
              {!licenceNumberNoShowError && (
                <div className="error-message  mb-3">
                  Licence Number does not exists
                </div>
              )}
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                6. Premise Code <span className="star">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="spremiseCode"
                placeholder=""
                maxLength={100}
                value={ipremiseCode}
                onChange={(event) => setiPremiseCode(event.target.value)}
                disabled={disableFormFields}
                onBlur={handlePremiseCodeBlur}
                required
              />
              <div className="invalid-feedback">
                Please provide premise code.
              </div>
              {!premiseCodeNoShowError && (
                <div className="error-message  mb-3">
                  Premise Code does not exists
                </div>
              )}
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                7. Organisational Address
              </label>
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress"
                      //placeholder="Address Type"
                      value={iorganizationAddress}
                      onChange={(e) => setiOrganizationAddress(e.target.value)}
                      disabled={disableFormFields}
                      required
                    >
                      <option value="">Address Type</option>
                      <option value="1">Local</option>
                      <option value="2">Foreign</option>
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                    <div className="invalid-feedback mb-3">
                      Please provide an Address Type.
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress2"
                      value={iorganizationAddress2}
                      onChange={(e) => setiOrganizationAddress2(e.target.value)}
                      disabled={disableFormFields}
                    >
                      <option value="">Select Type of Premises</option>
                      <option value="1">Cold Room[CR]</option>
                      <option value="2">
                        Factory and Processing Plant[FPP]
                      </option>
                      <option value="3">Farm[FM]</option>
                      <option value="4">Food Factory[FF]</option>
                      <option value="5">Office[OF]</option>
                      <option value="6">Residential[RE]</option>
                      <option value="7">Retail Outlet[RO]</option>
                      <option value="8">Show Room[SR]</option>
                      <option value="9">Warehouse[WH]</option>
                      <option value="10">FeedMill[FM]</option>
                      <option value="11">Others[OTHERS]</option>
                      <option value="10">Home[HO]</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress3"
                      placeholder="Block/House Number"
                      maxLength={4}
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={iorganizationAddress3}
                      onChange={blockNoHandler}
                      disabled={disableFormFields}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Block/House Num.
                    </div>
                    {!blockNoShowError && (
                      <div className="error-message">
                        Please enter charaters only. eg. "64FB"
                      </div>
                    )}
                  </div>
                </div>
                {/* <div className="col-lg-6">
                      <div className="mb-3">
                        <input
                          type="text"
                          className="form-control"
                          id="sorganizationAddress4"
                          placeholder="House Number"
                          maxLength={10}
                          value={sorganizationAddress4}
                          onChange={(event) =>
                            setsOrganizationAddress4(event.target.value)
                          }
                        />
                      </div>
                    </div> */}
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress6"
                      placeholder="Floor Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={iorganizationAddress6}
                      onChange={floorNoHandler}
                      disabled={disableFormFields}
                      maxLength={3}
                    />
                    {!floorNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "123"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress5"
                      placeholder="Street Name"
                      maxLength={64}
                      value={iorganizationAddress5}
                      onChange={(event) =>
                        setiOrganizationAddress5(event.target.value)
                      }
                      disabled={disableFormFields}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Street Name.
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress7"
                      placeholder="Unit Number"
                      pattern="^[a-zA-Z0-9\s]+$"
                      value={iorganizationAddress7}
                      onChange={unitNoHandler}
                      disabled={disableFormFields}
                      maxLength={4}
                    />
                    {!unitNoShowError && (
                      <div className="error-message  mb-3">
                        Please enter numbers eg. "1234"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress9"
                      placeholder="Postal Code"
                      maxLength={8}
                      pattern="[0-9]+"
                      value={iorganizationAddress9}
                      onChange={postalCodeHandler}
                      disabled={disableFormFields}
                      required
                    />
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>

                    <div className="invalid-feedback mb-3">
                      Please provide a Postal Code.
                    </div>
                    {!postalCodeShowError && (
                      <div className="error-message">
                        Please enter numbers only. eg. "123456"
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="sorganizationAddress8"
                      placeholder="Building Name"
                      maxLength={64}
                      value={iorganizationAddress8}
                      onChange={(event) =>
                        setiOrganizationAddress8(event.target.value)
                      }
                      disabled={disableFormFields}
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="mb-3 position-relative">
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      id="sorganizationAddress10"
                      value={iorganizationAddress10}
                      onChange={handleCountryChange}
                      // value={sorganizationAddress10}
                      // onChange={(e) =>
                      //   setsOrganizationAddress10(e.target.value)
                      // }
                      disabled={disableFormFields}
                      required
                    >
                      {countries.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <span
                      className="star csp-abs-ml-100-mt--30"
                    >
                      *
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                8. Mobile Number <span className="star">*</span>
              </label>

              <div className="row">
                <div className="col-md-2">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    id="smobilecode"
                    value={imobilecode}
                    onChange={(e) => setiMobileCode(e.target.value)}
                    disabled={disableFormFields}
                    required
                  >
                    {countryMobileCodes.map((code: any) => (
                      <option key={code} value={code}>
                        {code}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-10">
                  <input
                    type="text"
                    aria-describedby="emailHelp"
                    className="form-control"
                    id="smobileNo"
                    placeholder=""
                    pattern="[0-9]+"
                    value={imobileNo}
                    onChange={mobileNoHandler}
                    disabled={disableFormFields}
                    maxLength={12}
                    required
                  />
                  <div className="invalid-feedback">
                    Please provide a mobile.
                  </div>
                  {!validMobileNo && (
                    <div className="invalid-feedback">
                      Invalid mobile no. eg. +6591234567
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                9. Email<span className="star">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                id="semail"
                value={iemail}
                maxLength={255}
                onChange={handleEmailChange}
                disabled={disableFormFields}
                placeholder="Enter email"
                required
              />
              <div className="invalid-feedback">Please provide a email.</div>
              {!validEmail && (
                <p className="error-message">
                  Invalid email format. eg. abc@de.lk
                </p>
              )}
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                10. Brooder Microchip Number<span className="star">*</span>
              </label>
              <div className="rs-container">
                      <Select<Option,false>
                       classNamePrefix="rs"
                        id="brooderMicrochipNumber"
                        options={microchipNumbers}                        
                        value={brooderMicrochipNumber}
                        onChange={handleBrooderMicrochipChange}
                        required
                        isDisabled={disableFormFields}
                        placeholder="Select Brooder Microchip Number"                        
                        isSearchable={true}
                        isClearable={false}                       
                        maxMenuHeight={260}
                        menuPlacement="auto"
                        filterOption={(option, inputValue) =>
                          option.label != null && option.label.toString().includes(inputValue)
                        }
                      />
                      <div className="invalid-feedback">
                       Please provide Brooder Microchip Number.
                      </div>
                      </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                11. Quantity of harvested larvae/fry
                <span className="star">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                id="quantity"
                placeholder=""
                maxLength={100}
                value={quantity}
                onChange={(event) => setQuantity(event.target.value)}
                disabled={disableFormFields}
                required
              />
              <div className="invalid-feedback">
                Please provide Quantity of harvested larvae/fry.
              </div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                12. Variety<span className="star">*</span>
              </label>
              <select
                className="form-select"
                aria-label="Default select example"
                id="variety"
                value={variety}
                onChange={(e) => setVariety(e.target.value)}
                disabled
                required
              >
                <option value="" hidden>
                  Variety
                </option>
                <option value="1">Red [RED]</option>
                <option value="2">Gold [GOL]</option>
                <option value="3">Green [GRE]</option>
              </select>
              <div className="invalid-feedback">Please select a Variety.</div>
            </div>
            <div className="mb-2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                13. Harvest Date <span className="star">*</span>
              </label>
              <DatePicker
                id="sHarvestDate"
                selected={harvestDate}
                onChange={(date: Date | null) => setHarvestDate(date)}
                className="form-control"
                wrapperClassName="w-100"
                showIcon
                placeholderText="dd/mm/yyyy"
                dateFormat="dd/MM/yyyy"
                required
                disabled={disableFormFields}
              />
              {isValidDate && (
                <div className="invalid-feedback">
                  Please provide a Harvest Date.
                </div>
              )}

              {!isValidDate && (
                <p className="error-message">
                  Harvest date to be from Monday to Friday, excluding public
                  holidays.
                </p>
              )}
            </div>

            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                14. Harvest Time <span className="star">*</span>
              </label>
              <DatePicker
                id="sInspectionTime"
                selected={harvestTime}
                onChange={(date: Date | null) => {
                  setHarvestTime(date);
                }}
                className="form-control"
                wrapperClassName="w-100"
                showTimeSelect
                showTimeSelectOnly
                minTime={setHours(setMinutes(new Date(), 0), 9)}
                maxTime={setHours(setMinutes(new Date(), 0), 17)}
                placeholderText="HH:mm am"
                dateFormat="hh:mm aa"
                timeIntervals={30}
                required
                disabled={disableFormFields}
              />
              {!isTimeValid && (
                <div className="invalid-feedback mb-3">
                  Harvest time to be between 09:00 to 17:00.
                </div>
              )}
            </div>
            <div className="mb-2 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label mb-2"
              >
                15. Remarks
              </label>
              <input
                type="text"
                className="form-control"
                id="sRemarks"
                placeholder=""
                maxLength={500}
                value={aRemarks}
                onChange={(event) => setaRemarks(event.target.value)}
                disabled={disableFormFields}
              />
            </div>
            <div>
              <button
                type="button"
                className="btn btn-success mt-4"
                onClick={handleUploadButtonClick}
                disabled={disableUpload}
              >
                Upload Files
              </button>
              <input
                type="file"
                ref={fileInputRef}
                className="csp-display-none"
                onChange={handleFileChange}
                disabled={disableUpload}
                multiple
              />
              {selectedFiles &&
                selectedFiles.map((file, index) => (
                  <div>
                    <p>Selected File: {file.name}</p>
                    <p>File Size: {file.size} bytes</p>
                  </div>
                ))}
            </div>
            {showExtend && (
              <div>
                <div className="mb-2">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className={`form-label mb-2 ${
                      !isSalutationSelected() ? "required" : ""
                    }`}
                  >
                    Do you want to extend the expiry date?
                  </label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="extendExpiryDate"
                      value="1"
                      id="extendExpiryDateYes"
                      onChange={(e) => setExtendExpiryDate(e.target.value)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="extendExpiryDateYes"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="extendExpiryDate"
                      value="2"
                      id="extendExpiryDateNo"
                      onChange={(e) => setExtendExpiryDate(e.target.value)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="extendExpiryDateNo"
                    >
                      No
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="mb-3">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={site_Key}
              onChange={() => setIsCaptchaValid(true)}
              onExpired={() => setIsCaptchaValid(false)}
            />
            {submitted && !isCaptchaValid && (
              <div className="error-message">
                Please complete the reCAPTCHA verification.
              </div>
            )}
          </div>

          {showRFAFields && (
            <div>
              <div className="inst-cnt mt-2">
                <div className="mb-2 ">
                  <label
                    htmlFor="exampleFormControlInput1"
                    className="form-label mb-2"
                  >
                    Applicant's Comments
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="comments"
                    placeholder=""
                    maxLength={500}
                    value={comments}
                    onChange={(event) => setComments(event.target.value)}
                  />
                </div>
              </div>
            </div>
          )}

          <button
            type="submit"
            className="btn btn-success d-block mt-4"
            disabled={disableSubmit}
          >
            Submit
          </button>
          {isSubmiting && <Loader />}
          {errorMessage && <p>{errorMessage}</p>}

          <HarvestDetailsRFA RfaData={getRfaData}></HarvestDetailsRFA>
        </div>
      </form>
    </>
  );
};

export default HarvestDetailsRegistration;
